import SignUpPage from "./SignUpPage";

export { SignUpPage };

export default SignUpPage;
